import { Button, Dialog, makeStyles } from "@material-ui/core";
import React from "react";
import PsyDialog from "../PsyDialog/PsyDialog";
import { useTranslation } from "react-i18next";

const useStyles = makeStyles({
  wrapper: {
    display: "flex",
    gap: "0.5rem",
  },
});

const ConfirmDialog = ({
  cancelText,
  confirmText,
  onCancel,
  onConfirm,
  ...props
}) => {
  const styles = useStyles();
  const { t } = useTranslation(["components"]);

  return (
    <PsyDialog
      {...props}
      renderActions={() => {
        return (
          <div className={styles.wrapper}>
            <Button color="primary" variant="outlined" onClick={onCancel}>
              {cancelText || `${t("components:confirm_dialog.undo")}`}
            </Button>
            <Button color="primary" variant="contained" onClick={onConfirm}>
              {confirmText || `${t("components:confirm_dialog.confirm")}`}
            </Button>
          </div>
        );
      }}
    />
  );
};

export default ConfirmDialog;
